import React, {useState,useEffect,useRef} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso,CarouselImage,ProfilActionButton,Loading,ColumDataTableReorganize,articleColumnGenerate,customFieldsColumnGenerate,priceSuppColumnGenerate,tauxTvaColumnGenerate,enumereColumnGenerate,articleEditionDatatable,articleDataGenerator,ToastPopUp,ArticleBarSearch,ArticleFilterSearch2,EditModalActionButton,ModalSupplementList,ExportArticleButton,AddMarkExportForm,useLocalStorage,articlePriceUnitSuppDataGenerator} from "@gull";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import axios from 'axios'
import swal from "sweetalert2"
import Moment from 'react-moment';
import { useCookies} from 'react-cookie';
import {scrollXDataTable} from 'app/scrollXDataTable';
import { Modal } from "react-bootstrap";
import {articleListErp} from 'app/columnsArticleListeDataTable'
import { devises_list } from "app/devises";
import { articleHardData } from 'app/articleHardData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlus } from '@fortawesome/free-solid-svg-icons';

const useLoad = () => {
    const t = useTranslate();
    const [datas,setDatas]=useState([])
    const [datasSize,setDatasSize]=useState(0)
    const [loading,setLoading]=useState(true)
    const [reloadData,setReloadData] = useState(Date.now())
    const [sendData, setSendData] = useState({})
    
    const [customFields,setCustomFields]=useState([])
    const [liaisons,setLiaisons]=useState([])
    const [customInterface, setCustomInterface] = useState({})
    
    const [optionsDataTable,setOptionsDataTable]=useState({
        devise:[],
        marque:[],
        fournisseur:[],
        firstlevelcat:[],
        secondlevelcat:[],
        thirdlevelcat:[],
        fourthlevelcat:[],
        fifthlevelcat:[]

    })
    const [ourOptionsDataTable,setOurOptionsDataTable]=useState({
        devise:{},
        marque:{},
        fournisseur:{},
        firstlevelcat:{},
        secondlevelcat:{},
        thirdlevelcat:{},
        fourthlevelcat:{},
        fifthlevelcat:{}

    })

    const [filtre, setFiltre] = useState({})
    const [page,setPage]=useState(1)
    const [perPage,setPerPage]=useState(50)

    useEffect(function () {
        (async function() {
            setCustomInterface({})
            const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/all_article/"+perPage+"/1",filtre
            ).then((response) => {
                setDatas(response.data.datas)
                setDatasSize(response.data.count)
                let allFilter = {
                    havestock:"",
                    sortField:"",
                    sortOrder:""
                };
                if(response.data.custom_interface.user_conf){
                    response.data.custom_interface.user_conf.details.map(value=>
                        allFilter[value]=[]
                    )
                }else if(response.data.custom_interface.default_conf){
                    response.data.custom_interface.default_conf.details.map(value=>
                        allFilter[value]=[]
                    )
                }

                setSendData(allFilter)
                setCustomInterface(response.data.custom_interface)
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setLoading(false)
        })()
    }, [reloadData])

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_fields/all/article"
            ).then((response) => {
                setCustomFields(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                swal.fire(t(messageError), "", "error");
            })
        })()
    }, [])

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/liaison"
            ).then((response) => {
                setLiaisons(response.data.datas)

                let arr = ['firstlevelcat','secondlevelcat','thirdlevelcat','fourthlevelcat','fifthlevelcat','fournisseur','marque']
                //on crée une zone de stockage temporaire des données avant de tout set
                let optionsDataTableTemp = optionsDataTable
                let ourOptionsDataTableTemp = ourOptionsDataTable
                
                //formatage des options du select dans le cell edit du datatable pour les devises
                let arrDevise=[]
                let objDeviseOur={}
                devises_list.map(value=>{
                    arrDevise.push({'value':value.name+" - "+value.code,'label':value.name+" - "+value.code})
                    objDeviseOur[value.name+" - "+value.code]=value.code
                })

                optionsDataTableTemp={...optionsDataTableTemp,devise:arrDevise}
                ourOptionsDataTableTemp={...ourOptionsDataTableTemp,devise:objDeviseOur}

                //formatage des options du select dans le cell edit du datatable pour le reste des colones
                arr.forEach(item=>{
                    let optionsArr = [{'value':t('emptyValue'),'label':t('emptyValue')}]
                    let ourOptionObj = {}

                    ourOptionObj[t('emptyValue')]=''
                    response.data.datas[item].map(value=>{
                        optionsArr.push({'value':value.name,'label':value.name})
                        ourOptionObj[value.name]=value.id
                    })

                    optionsDataTableTemp={...optionsDataTableTemp,[item]:optionsArr}
                    ourOptionsDataTableTemp={...ourOptionsDataTableTemp,[item]:ourOptionObj}
                })

                setOptionsDataTable(optionsDataTableTemp)
                setOurOptionsDataTable(ourOptionsDataTableTemp)
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
        })()
    }, [])

    return [loading,datas,setDatas,datasSize,setDatasSize,reloadData,setReloadData,customFields,liaisons,customInterface,setCustomInterface,optionsDataTable,ourOptionsDataTable,filtre,setFiltre,perPage,setPerPage,sendData,setSendData,page,setPage]
} 

const useLoadInit= () => {
    const t = useTranslate();

    // Pour searchbar Article
    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datasItem,setDatasItem] = useState(listSearchItem)
    const searchInput = useRef('')
    
    const loadItems = async (inputValue) => {
        setLoadingSearchItem(true)
        
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/article_name/"+encodeURIComponent(inputValue)
        ).then((response) => {
            setLoadingSearchItem(false)
            setListSearchItem(response.data.datas)
            let ajour = response.data.datas.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            setDatasItem(ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchItem(false)
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }
    // end

    return [loadingSearchItem,setLoadingSearchItem,listSearchItem,setListSearchItem,datasItem,setDatasItem,searchInput,loadItems]
}

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columnShow.length)
    }, [window.screen.width,props.columnShow.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            remote
            pagination={paginationFactory(props.paginationOptions)}
            onTableChange={ props.handleTableChange }
            noDataIndication={t('tableNoData')}
            defaultSortDirection={props.defaultSortDirection}
            hover
            condensed
            responsive
        />
    );
};

const ItemsSupplementListArticleTable = (props) => {
    const t = useTranslate();
    const moduleErp = props.authParam.modules.find(value=>value.name=='erp')

    const [loading,datas,setDatas,datasSize,setDatasSize,reloadData,setReloadData,customFields,liaisons,customInterface,setCustomInterface,optionsDataTable,ourOptionsDataTable,filtre,setFiltre,perPage,setPerPage,sendData,setSendData,page,setPage]=useLoad()
    const [cookies, setCookie] = useCookies(['supplement_list_article_fields','supplement_list_article_reorganize']);
    const [localStorage, setLocalStorage] = useLocalStorage(['supplement_list_article_fields','article_fields_reorganize']);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage.supplement_list_article_fields && cookies.supplement_list_article_fields){
            setLocalStorage('supplement_list_article_fields',cookies.supplement_list_article_fields);
        }
        if(!localStorage.supplement_list_article_reorganize && cookies.supplement_list_article_reorganize){
            setLocalStorage('supplement_list_article_reorganize',cookies.supplement_list_article_reorganize);
        }
    }, []);
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 
    
    // Pour le datatable
    const maxConditionnement = (props.authParam.company.advanceparams.max_conditionnement!='' && props.authParam.company.advanceparams.max_conditionnement!=null) ? +props.authParam.company.advanceparams.max_conditionnement : 0
    const suppPrice = props.authParam.company.advanceparams.hasOwnProperty('prix_supplementaire') ? props.authParam.company.advanceparams.prix_supplementaire : []
    const categorieTva = (props.authParam.company.advanceparams.hasOwnProperty('categorie_tva') && props.authParam.company.advanceparams.categorie_tva!=null) ? props.authParam.company.advanceparams.categorie_tva : []
    // end

    // Pour searchbar
    const [loadingSearchItem,setLoadingSearchItem,listSearchItem,setListSearchItem,datasItem,setDatasItem,searchInput,loadItems] = useLoadInit()
    const [inputScan,setInputScan]=useState('')
    // end
    
    // Favoris
    const [toast,setToast]=useState(false) 
    const [showModalCustomFiltre, setShowModalCustomFiltre] = useState(false);
    const tableName = "baseArticle" //Qui est l'identifiant pour le composant ArticleFilterSearch2, qui permet de créer et rcupérer les favoris
    const [clearTable,setClearTable]=useState(false) 
    // end

    // Affichage filtre
    const [showAccordion,setShowAccordion]=useState(false) 

    //Pour le carousel
    const [showCarousel,setShowCarousel]=useState(false) 
    const [modalItemName,setModalItemName]=useState('') 
    const [modalImage,setModalImage]=useState('') 

    // Modal d'édition de liste de supplément
    const [showModal,setShowModal]=useState(false) //Pour affichage modal
    const [dataNextList,setDataNextList] = useState([])
    const [lastListClicked,setLastListClicked]=useState([])
    const [editArticleId,setEditArticleId]=useState(false)

    const [showAddArticle, setShowAddArticle] = useState(false) // Ajout d'article via searchBar
        
    let cookieLecture = ['internalid','name','reference','price','action'];
    if(localStorage.supplement_list_article_fields){
        let columnShowVar = localStorage.supplement_list_article_fields;
        cookieLecture = columnShowVar.split(',')
    }
    const [columnShow,setColumnShow] = useState(cookieLecture)   

    // Export CSV
    const [lang, setLang] = useCookies(['lang']);
    const [headerColumnShowExport,setHeaderColumnShowExport]=useState('') 
    const [addMark,setAddMark]=useState(true) 

    useEffect(function () {
        let headerColumnShowExportArr = [] 
        
        columnOrganize.map(value=>{
            if(columnShow.includes(value.dataField)) headerColumnShowExportArr.push(value.dataField)
        })
        setHeaderColumnShowExport(headerColumnShowExportArr.join(',').replace('action,',''))
    }, [columnShow,columnOrganize])

    let headerAllExport = (localStorage.supplement_list_article_reorganize) ? localStorage.supplement_list_article_reorganize.replace('action,masque,','') : 'all'
    // end

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    const headerSortingStyle = { backgroundColor: '#c8e6c9' };

    const openModalCarousel = (image,itemName) =>{
        setModalImage(image)
        setModalItemName(itemName)
        setShowCarousel(true)
    }

    const closeModalCarousel = () =>{
        setModalImage('')
        setModalItemName('')
        setShowCarousel(false)
    }

    let dataTable = new Array
    datas && datas.length!=0 && datas.forEach((value,ind)=>{
        let obj = {
            id:value.id,
            internalid: value.internalid,
            name:value.name,
            created_at: <Moment format="DD/MM/YYYY">{value.created_at}</Moment>,
            masque:'',
            action: 
                <span className="d-flex justify-content-between">
                    <ProfilActionButton path={'/erp/article/edit/'+value.id}/> 
                    <EditModalActionButton index={value.id} hisId={value.id} setModalEditId={setEditArticleId} paramShow={value.id} setShowEdit={setShowModal} />
                </span>,
            index:ind
        }
        articleDataGenerator(obj,value,t,openModalCarousel)
        articlePriceUnitSuppDataGenerator(obj,value,suppPrice)
        customFields.forEach((item,index)=>{
            if(value.custom_fields){
                obj[item.name]=value.custom_fields[item.name]
            }
        })

        for (let i=0; i<maxConditionnement; i++){
            let numeroEnumere = i+1
            obj['name_'+numeroEnumere]= (value.hasOwnProperty('name_'+numeroEnumere) && value['name_'+numeroEnumere]!=null) ? value['name_'+numeroEnumere] : ''
            obj['reference_'+numeroEnumere]= (value.hasOwnProperty('reference_'+numeroEnumere) && value['reference_'+numeroEnumere]!=null) ? value['reference_'+numeroEnumere] : ''
            obj['quantity_'+numeroEnumere]= (value.hasOwnProperty('quantity_'+numeroEnumere) && value['quantity_'+numeroEnumere]!=null) ? value['quantity_'+numeroEnumere] : ''
        }

        suppPrice.map((item,index)=>{
            let numero = index+1
            let margePrixSupp = (value.hasOwnProperty('margeN_'+item['designation_'+numero]) && value['margeN_'+item['designation_'+numero]]!=null && value['margeN_'+item['designation_'+numero]]!=0) ? value['margeN_'+item['designation_'+numero]] : 0

            let margePercentPrixSupp = (value.hasOwnProperty('margeP_'+item['designation_'+numero]) && value['margeP_'+item['designation_'+numero]]!=null && value['margeP_'+item['designation_'+numero]]!=0) ? value['margeP_'+item['designation_'+numero]] : 0


            obj['price_'+item['designation_'+numero]]= (value.hasOwnProperty('price_'+item['designation_'+numero]) && value['price_'+item['designation_'+numero]]!==null && value['price_'+item['designation_'+numero]]!=='') ? value['price_'+item['designation_'+numero]] : ''

            obj['price_'+item['designation_'+numero]+'_ttc']= (value.hasOwnProperty('price_'+item['designation_'+numero]+'_ttc') && value['price_'+item['designation_'+numero]+'_ttc']!==null && value['price_'+item['designation_'+numero]+'_ttc']!=='') ? value['price_'+item['designation_'+numero]+'_ttc'] : ''

            obj['margeN_'+item['designation_'+numero]]= margePrixSupp

            obj['margeP_'+item['designation_'+numero]]= margePercentPrixSupp
        })

        categorieTva.map((categorie)=>{
            obj['taux_'+categorie.name]= (value.hasOwnProperty('taux_'+categorie.name) && value['taux_'+categorie.name]!=null) ? value['taux_'+categorie.name] : ''
        })

        dataTable.push(obj)
    })

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        page:page,
        showTotal: true,
        totalSize: datasSize
    };

    let columnsInit = [
        {
            dataField: "action",
            text: 'Actions',
            editable: false,
        },
        {
            dataField: "internalid",
            text: t('internalId'),
            hidden: (columnShow.includes("internalid")) ? false : true,
            editable: false,
            sort: true,
        },
        {
            dataField: "created_at",
            text: t('createdAt'),
            hidden: (columnShow.includes("created_at")) ? false : true,
            editable: false,
            sort: true,
        },
    ];

    let columns=[
        ...columnsInit,
        ...articleColumnGenerate(articleListErp,columnShow,headerSortingStyle,articleEditionDatatable,optionsDataTable,ourOptionsDataTable,t,props.authParam),
        ...enumereColumnGenerate(maxConditionnement,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam),
        ...priceSuppColumnGenerate(suppPrice,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam),
        ...tauxTvaColumnGenerate(categorieTva,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam),
        ...customFieldsColumnGenerate(customFields,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam)
    ]

    // Organisation des columns
    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.supplement_list_article_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.supplement_list_article_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("supplement_list_article_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [customFields])
    
    // Columns affiché
    useEffect(function () {
        if(localStorage.supplement_list_article_fields){
            let cookieColumnShow = localStorage.supplement_list_article_fields.split(',')
            let columnsDatas = [] //contient toutes les dataFields de columns
            let arrColumnShow = [] //contient toutes les données sans doublons
            let arrColumnShowDoublon = [] //contient les doublons
            let arrColumnShowIntrus = [] // continent les fausse données

            columns.map(item=>{
                columnsDatas.push(item.dataField)
            })

            cookieColumnShow.map(value=>{
                //on vérifie si le cookie contien des doublons
                if(!arrColumnShow.includes(value)){
                    arrColumnShow.push(value)
                }else{
                    //Si value existe dejà c'est qu'il y a un doublon 
                    arrColumnShowDoublon.push(value)
                }
                //on vérifie si les données du cookies sont des données qui exisent dans le tableau columns
                if(!columnsDatas.includes(value)) arrColumnShowIntrus.push(value)
                
            })

            if(arrColumnShowDoublon.length!=0 || arrColumnShowIntrus.length!=0){ 
                //Si le cookie contient des doublons et des données qui n'existe pas en meme temps
                let uniformData = arrColumnShow.filter(value=> !arrColumnShowIntrus.includes(value))

                setLocalStorage("supplement_list_article_fields",uniformData.join(),{ path: "/", expires: expire_date })
            }
        }
    }, [])

    // Pour récupérer un article avec la searchbar
    const addNewItem = async (e,articleid,inputname,articleBar) =>{
        if(e){
            setLoadingSearchItem(true)
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/reference/"+e.target.value
            ).then((response) => {
                if(response.data.hasOwnProperty('valid') && !response.data.valid){
                    swal.fire(t('articleNoReferenceFind'), "", "error");
                }else{ 
                    setShowModal(response.data.data.article.id)
                    setEditArticleId(response.data.data.article.id)
                    setInputScan('')
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
            setLoadingSearchItem(false)

        }else{
            setShowModal(articleid)
            setEditArticleId(articleid)
            setInputScan('')
        }
    }

    // Organisation des colonnes
    const handleToggleColumns = (column,indexToEdit) => {
        if(column.toggle){
            var newColumnShow = columnShow.filter(value=>value!=column.dataField)

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = true

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
            
        }
        else{
            var newColumnShow = [...columnShow,column.dataField]

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = false

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
        }
        setLocalStorage("supplement_list_article_fields",newColumnShow.join(),{ path: "/", expires: expire_date }) 
    }

    // Changement d'état du tableau
    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder}) => {
        let objFiltre 

        if(type=='sort'){
            objFiltre = {
                ...filtre,
                sortField:sortField,
                sortOrder:sortOrder
            }
            setFiltre(objFiltre)
            setSendData({
                ...sendData,
                sortField:sortField,
                sortOrder:sortOrder
            })
        }else{
            objFiltre = filtre
        }

        setPerPage(sizePerPage)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/all_article/"+sizePerPage+"/"+page,objFiltre
            ).then((response) => {
                setDatas(response.data.datas)
                setDatasSize(response.data.count)
                setPage(page)
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
    }

    // Sélection filtre
    const handleSelect = (e,nameInput) => {
        setSendData({...sendData,[nameInput]:e.target.value})
    }

    const handleBool = (e,nameInput) => {
        setSendData({...sendData,[nameInput]:e.target.checked})
    }
    // end

    // Bouton affichage filtre accordion
    const CustomToggleAccordion = ({ children }) => {
    
        let hisClass = (showAccordion) ? "btn btn-sm btn-primary mb-3" : "btn btn-sm btn-outline-primary mb-3"
        
        return (
            <button
                type="button"
                className={hisClass}
                style={{marginRight:'10px'}}
                onClickCapture={()=>setShowAccordion(!showAccordion)}
            >
                {children}
            </button>
        );
    }

    // Fermeture modal supplément liste
    const onCloseModal = () => {
        setShowModal(false)
        setDataNextList([])
        setLastListClicked([])
        setEditArticleId(false)
        setReloadData(Date.now())
    }

    if(loading){
        return (<Loading></Loading>);
    }
    return ( <>
        <Modal show={showCarousel} onHide={()=>closeModalCarousel()}>
            <Modal.Header closeButton>
                <Modal.Title>{modalItemName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CarouselImage images={modalImage} />
            </Modal.Body>
        </Modal>
        <Modal size="xl" show={showModal} onHide={() => onCloseModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{t('supplementList')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalSupplementList
                    key={(!showModal) ? `modal-closed` : `modal-${showModal}`}
                    articleId={showModal}
                    editArticleId={editArticleId}
                    setEditArticleId={setEditArticleId}

                    // Pour affichage des listes suivantes
                    dataNextList={dataNextList}
                    setDataNextList={setDataNextList}
                    // Pour affichage des listes précédentes
                    lastListClicked={lastListClicked}
                    setLastListClicked={setLastListClicked}
                    from="erp"
                />
            </Modal.Body>
        </Modal>
        <ToastPopUp 
            showToast={toast}
            setShowToast={setToast}
            message={t('favoriteSaved')}
        />
        <CardPerso header={
            <>
                {t('items')}&nbsp;&nbsp;
            </>
        }>
            <small>
                <ToolkitProvider
                    keyField="index"
                    data={dataTable}
                    columnToggle
                    columns={columnOrganize}
                    hover
                    condensed
                    responsive
                >
                {(propst) => (
                    <>
                        <div className="alert alert-info">{t('infoSupplementListArticle')}</div>
                        <div className="row d-flex justify-content-between">
                            <div className="col d-flex align-items-baseline">
                                <CustomToggleAccordion>{t('filtres')}</CustomToggleAccordion>
                                <ColumDataTableReorganize 
                                    columnOrganize={columnOrganize}
                                    setColumnOrganize={setColumnOrganize}
                                    setCookie={setLocalStorage}
                                    cookieName='supplement_list_article_reorganize'
                                    { ...propst.columnToggleProps } 
                                    executWhenToggle={handleToggleColumns}
                                    showColumnOrganize={showColumnOrganize}
                                    setShowColumnOrganize={setShowColumnOrganize}
                                    btnSwitch={true}//pour affiche ou non le btn swith
                                    initSwith={false}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                />&nbsp;&nbsp;&nbsp;
                                <ExportArticleButton sizeDatas={datasSize} filtre={filtre} addMark={addMark} lang={lang.lang} header={headerColumnShowExport} title={t('downloadCSVSelection')} type="button" url={"api/erp/supplement_list/csvitem"}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                <ExportArticleButton sizeDatas={datasSize} filtre={filtre} addMark={addMark} lang={lang.lang} header={headerAllExport} title={t('downloadCSVAll')} type="button" url={"api/erp/supplement_list/csvitem"}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                <div className="d-flex align-self-start">
                                    <AddMarkExportForm setAddMark={setAddMark} addMark={addMark} />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3 form-group">
                            <div className='col-auto'>
                                <label>
                                    {t('configArticleSupplementList')}:
                                </label>
                            </div>
                            {(showAddArticle==false) ?
                                <div className='col-auto'>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-success"
                                        onClick={()=>setShowAddArticle(true)}
                                    >
                                        <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                </div>
                            :
                                <>
                                    <div className="col-4 d-flex align-items-baseline">
                                        <ArticleBarSearch
                                            loadingSearchItem={loadingSearchItem}
                                            loadItems={loadItems}
                                            listSearchItem={listSearchItem}
                                            datas={datasItem}
                                            setDatas={setDatasItem}
                                            valueInput={inputScan}
                                            setValueInput={setInputScan}
                                            handleSubmit={addNewItem}
                                            searchInput={searchInput}
                                            noBlur={false}
                                        />
                                    </div>
                                    <div className='col-auto'>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-danger"
                                            onClick={()=>setShowAddArticle(false)}
                                        >
                                            <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                    </div>
                                </>
                            }
                        </div>
                        {(showAccordion) &&
                            <div className="row mb-3">
                                <div className="col">
                                    <ArticleFilterSearch2
                                        liaisons={liaisons}
                                        customFields={customFields} 
                                        setDataTable={setDatas} 
                                        setSizeDatas={setDatasSize} 
                                        setFiltre={setFiltre} 
                                        perPage={perPage}
                                        customInterface={customInterface}
                                        setCustomInterface={setCustomInterface}
                                        setReload={setReloadData}
                                        sendData={sendData}
                                        setSendData={setSendData}
                                        setShowModalCustomFiltre={setShowModalCustomFiltre}
                                        showModalCustomFiltre={showModalCustomFiltre}
                                        initAllFilter={{
                                            archive:false,
                                            stock:false,
                                            provisoire:false,
                                            havestock:"",
                                        }}
                                        interface='filtreArticle' //Variable qui permet d'identifier l'url sur laquelle filtrer
                                        hardData={articleHardData}
                                        moduleName='supplementList'
                                        setCurrentPage={setPage}
                                        setClearTable={setClearTable}

                                        tableName={tableName}
                                        setToast={setToast}
                                    >
                                        <div className="row">
                                            {(moduleErp.params.stock.active) &&
                                                <div className="col-lg-3 col-md-4 col-6">
                                                    <div className="form-group">
                                                        <label className="col-form-label col-form-label-sm">{t('itemHaveStock')}</label>
                                                        <select className="form-control form-control-sm" value={sendData.havestock} onChange={(e) => handleSelect(e,'havestock')}>
                                                            <option value="">{t('itemLinkAndNotLinkToTock')}</option>
                                                            <option value="oui">{t('itemLinkToTock')}</option>
                                                            <option value="non">{t('itemNotLinkToTock')}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            }
                                            <div className="col-lg-3 col-md-4 col-6">
                                                <div className="form-group mt-2">
                                                    <div className="col-12">
                                                        <div className="form-check form-switch">
                                                            <input type="checkbox" className="form-check-input"  checked={(sendData.archive) ? sendData.archive : false} onChange={(e) => handleBool(e,'archive')}/>
                                                            <label className="form-check-label">{t('includeArchivetem')}</label>
                                                        </div>
                                                        <div className="form-check form-switch">
                                                            <input type="checkbox" className="form-check-input"  checked={(sendData.provisoire) ? sendData.provisoire : false} onChange={(e) => handleBool(e,'provisoire')}/>
                                                            <label className="form-check-label">{t('showOnlyTemporaryItem')}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ArticleFilterSearch2>
                                </div>
                            </div>
                        }
                        {!clearTable &&
                            <div className="position-relative">
                                <CustomDataTable 
                                    propst={propst}
                                    paginationOptions={paginationOptions}
                                    columnShow={columnShow}
                                    defaultSortDirection="asc"
                                    handleTableChange={handleTableChange}
                                />
                            </div>
                        }
                    </>
                )}
                </ToolkitProvider>
            </small>
        </CardPerso>
    </>);
}

export default ItemsSupplementListArticleTable;
